/* ============================================================
   APARU — Overlays entzerren

   Cookie-Banner und Newsletter-Popup starten im Theme jeweils
   einen eigenen setTimeout und wissen nichts voneinander. Beim
   ersten Besuch erscheinen sie dadurch uebereinander.

   Reihenfolge hier: Zuerst die Einwilligung, danach das Angebot.
   Das Popup wird zurueckgehalten, solange der Banner sichtbar
   ist, und erst einige Sekunden nach dessen Verschwinden geoeffnet.

   Greift nur ein, wenn beide Elemente existieren. Faellt eines
   weg, verhaelt sich das andere unveraendert.
   ============================================================ */
(function () {
  var PAUSE_NACH_BANNER = 5000;

  function bereit(versuch) {
    var pp = document.querySelector('promo-popup');
    var cb = document.querySelector('cookie-banner');

    if ((!pp || typeof pp.open !== 'function') && versuch < 40) {
      return setTimeout(function () { bereit(versuch + 1); }, 100);
    }
    if (!pp || !cb || typeof pp.open !== 'function') return;

    /* Der Host <cookie-banner> traegt DAUERHAFT class="hidden".
       Der sichtbare Zustand liegt auf dem inneren .cookie-banner
       mit der Klasse is-active (siehe cookie-banner.js: open()).
       Am Host zu pruefen liefert immer "unsichtbar". */
    function bannerSichtbar() {
      var b = cb.querySelector('.cookie-banner');
      return !!(b && b.classList.contains('is-active'));
    }

    var originalOpen = pp.open.bind(pp);
    var zurueckgehalten = false;

    pp.open = function () {
      if (bannerSichtbar()) { zurueckgehalten = true; return; }
      originalOpen();
    };

    var beobachter = new MutationObserver(function () {
      if (bannerSichtbar() || !zurueckgehalten) return;
      zurueckgehalten = false;
      beobachter.disconnect();
      setTimeout(originalOpen, PAUSE_NACH_BANNER);
    });
    beobachter.observe(cb, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bereit(0); });
  } else {
    bereit(0);
  }
})();
